module.exports = __webpack_public_path__ + "img/ep-chene.5bc323a5.jpg";